import {
  RequestTrackingStatisticsResponse,
  GetTrackingStatisticsRequest,
  GetRequestsByDeviceRequest,
  GetErrorDistributionRequest,
  GetRequestsByModeRequest,
  RequestTrackingPageResponse,
} from '@openapi';
import { getRequestTrackingApi } from './configuration';

const tracking = {
  getStatistics: (requestParameters?: GetTrackingStatisticsRequest): Promise<RequestTrackingStatisticsResponse> => {
    return getRequestTrackingApi().getTrackingStatistics(requestParameters);
  },

  getDailyStatistics: (): Promise<RequestTrackingStatisticsResponse> => {
    return getRequestTrackingApi().getDailyTrackingStatistics();
  },

  getWeeklyStatistics: (): Promise<RequestTrackingStatisticsResponse> => {
    return getRequestTrackingApi().getWeeklyTrackingStatistics();
  },

  getMonthlyStatistics: (): Promise<RequestTrackingStatisticsResponse> => {
    return getRequestTrackingApi().getMonthlyTrackingStatistics();
  },

  getRequestsByMode: (requestParameters?: GetRequestsByModeRequest): Promise<RequestTrackingPageResponse> => {
    return getRequestTrackingApi().getRequestsByMode(requestParameters);
  },

  getRequestsByDevice: (requestParameters: GetRequestsByDeviceRequest): Promise<RequestTrackingPageResponse> => {
    return getRequestTrackingApi().getRequestsByDevice(requestParameters);
  },

  getErrorDistribution: (requestParameters?: GetErrorDistributionRequest): Promise<Record<string, number>> => {
    return getRequestTrackingApi().getErrorDistribution(requestParameters) as Promise<Record<string, number>>;
  },
};

export default tracking;
